module.exports = __webpack_public_path__ + "img/braking-force.fef25f8e.png";